import dayjs from 'dayjs'
export const displayFormatWithWeekDay = 'YYYY年M月D日（dd）'
export const displayFormatWithWeekDayTime = `${displayFormatWithWeekDay} HH:mm`
export const displayFormat = 'YYYY年M月D日'
export const validateFormatWithoutTime = 'YYYY/M/D'
export const startDate = (startsAt: string):dayjs.Dayjs => {
  return dayjs(startsAt, validateFormatWithoutTime)
}
export const addMonthDate = (start: dayjs.Dayjs, range: number) => {
  return start.add(Number(range), 'month')
}
export const addDayDate = (start: dayjs.Dayjs, range: number) => {
  return start.add(Number(range), 'day')
}
export const monthString = (month:number) => {
  if (month === 12) {
    return '1年'
  } else {
    return `${month}ヶ月`
  }
}
export interface LimitedDates {
  start: string
  start_only_dates: string
  end: string
  end_only_dates: string
  range: string
  available: string
}
export const limitedDates = (startsAt: string, rangeMonth: number, availableDay: number): LimitedDates => {
  const start = startDate(startsAt)
  const end = addMonthDate(start, rangeMonth)
  return {
    start: start.format(displayFormatWithWeekDayTime),
    start_only_dates: start.format(displayFormat),
    end: end.format(displayFormatWithWeekDay),
    end_only_dates: end.format(displayFormat),
    range: monthString(rangeMonth),
    available: addDayDate(end, availableDay).format(displayFormatWithWeekDay)
  }
}